import React, { useState, useMemo } from "react";
import AddPropertyContext from "./AddPropertyContext";

const AddPropertyState = (props) => {
  const [state, setState] = useState({
    id: "",
    label: "",
    imageUrl: "",
    imageName: "",
    link: "/collections",
    accent: "#10b981",
    order: 1,
    isActive: true,
  });

  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state]
  );

  return (
    <AddPropertyContext.Provider value={value}>
      {props.children}
    </AddPropertyContext.Provider>
  );
};

export default AddPropertyState;
